export default __webpack_public_path__ + "static/media/controlLogOff24.56f9e765.svg";